import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

Swiper.use([Navigation, Pagination]);

export default function BlogHeroSlider() {
  const blogHeroSlider = document.querySelector('.js-blog-hero-slider');

  if (!blogHeroSlider) {
    return;
  }

  // Initialize Swiper
  const swiper = new Swiper(blogHeroSlider, {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: false,
    //   pauseOnMouseEnter: true,
    // },
    autoplay: false,
    speed: 600,
    effect: 'slide',
  });

  // Custom pagination functionality
  const paginationBullets = document.querySelectorAll('.js-blog-hero-pagination-bullet');
  const prevButton = document.querySelector('.js-blog-hero-prev');
  const nextButton = document.querySelector('.js-blog-hero-next');
  const readMoreLink = document.querySelector('.js-blog-hero-read-more');

  // Function to update Read more link
  const updateReadMoreLink = (realIndex) => {
    if (readMoreLink) {
      const slides = document.querySelectorAll('.js-blog-hero-slider .swiper-slide');
      if (slides[realIndex]) {
        const articleLink = slides[realIndex].getAttribute('data-article-link');
        if (articleLink) {
          readMoreLink.setAttribute('href', articleLink);
        }
      }
    }
  };

  if (paginationBullets.length > 0) {
    // Handle pagination bullet clicks
    paginationBullets.forEach((bullet, index) => {
      bullet.addEventListener('click', () => {
        swiper.slideToLoop(index);
      });
    });

    // Update pagination bullets and Read more link on slide change
    swiper.on('slideChange', () => {
      const realIndex = swiper.realIndex;

      paginationBullets.forEach((bullet, index) => {
        if (index === realIndex) {
          // Active bullet - wider and primary color
          bullet.classList.remove('w-3', 'bg-neutral-alt');
          bullet.classList.add('w-12', 'bg-primary');
        } else {
          // Inactive bullet - narrower and neutral color
          bullet.classList.remove('w-12', 'bg-primary');
          bullet.classList.add('w-3', 'bg-neutral-alt');
        }
      });

      // Update Read more link
      updateReadMoreLink(realIndex);
    });
  }

  // Handle prev/next button clicks
  if (prevButton) {
    prevButton.addEventListener('click', () => {
      swiper.slidePrev();
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', () => {
      swiper.slideNext();
    });
  }
}
